import React from 'react';

import { Container, Stack, Button, Typography } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import { SlideIn } from '../SlideIn';

export default function WelcomeContent({ onNext }) {
  const { logout } = useAuthContext();
  return (
    <Stack spacing={4} alignItems="center" justifyContent="center" textAlign="center">
      <SlideIn direction="left">
        <Typography variant="h2" color="text.secondary">
          🌾 🍞
        </Typography>
        <Typography variant="h1">GrowBread</Typography>
        <SlideIn direction="left">
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Welcome to GrowBread Application Onboarding.
          </Typography>
        </SlideIn>

        <Container maxWidth="md">
          <Typography variant="h5" fontWeight="medium" gutterBottom>
            How long will this take?
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            If you have what you need as identified below, it should take less than 10 minutes.
          </Typography>

          <Typography variant="h5" fontWeight="medium" gutterBottom>
            What you will need
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            1. Your user ID and password to each of the accounts that you want to integrate into
            GrowBread. GrowBread can securely integrate your data into GrowBread using only methods
            approved by your financial institutions. Most supported banks, brokerage companies,
            lenders, and other financial market participants allow their data to be immediately
            integrated; some require additional authorization, which can take more time.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            2. An estimate of your social security retirement income or your willingness to onboard
            and start with the national average and modify it later.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            3. An estimate of your retirement income withdrawal rate or your willingness to onboard
            and start with the national average and modify it later.
          </Typography>

          <Typography variant="h5" fontWeight="medium" gutterBottom>
            What Will Happen During Onboarding
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            1. You enter at least your name, address, and a valid email address.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            2. You enter your financial account credentials.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            3. You confirm retirement assumptions as the national average or update the estimated
            Social Security amount and retirement account withdrawal rate when retired.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            4. GrowBread does the rest, including creating a draft personal budget based on your
            last 24 months of transactions that are integrated. In some cases, these can be very
            representative of the budget forward; in many cases, it may need edits because expenses
            or income from the last two years are unlikely to represent future expenses or income.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            5. You will begin to better understand and plan your financial future.
          </Typography>
        </Container>
      </SlideIn>

      <SlideIn direction="none">
        <Stack spacing={4}>
          <Typography variant="body2" color="text.secondary">
            Let&apos;s get started by connecting your financial institution.
          </Typography>
          <Button variant="contained" color="primary" size="large" onClick={() => onNext()}>
            Connect Accounts Now
          </Button>
          <Button onClick={logout}>or logout</Button>
        </Stack>
      </SlideIn>
    </Stack>
  );
}
